import {FiActivity} from "react-icons/fi";

import {Divider} from "@/components/divider/Divider.tsx";
import {Icon} from "@/components/icon/Icon.tsx";

import {formatDurationRounded} from "../../utils/uptimeBarEvents.ts";
import {STATUS_ICON} from "./statusIcons.ts";

import styles from "./StatusPageUptimeBarTooltip.module.scss";

export interface AffectedComponentItem {
  key: string | number;
  name: string;
  status: string;
  // When set, a downtime duration is shown after the name (check-based); omit for incidents.
  durationSecs?: number;
}

interface AffectedComponentsListProps {
  items: AffectedComponentItem[];
  maxListLength: number;
}

export const AffectedComponentsList = ({items, maxListLength}: AffectedComponentsListProps) => {
  if (items.length === 0) return null;

  return (
    <>
      <Divider />
      <div className={styles.section}>
        <div className={styles.sectionTitle}>Affected Components ({items.length})</div>
        <div className={styles.componentList}>
          {items.slice(0, maxListLength).map((item) => (
            <div key={item.key} className={styles.componentItem}>
              <Icon
                icon={STATUS_ICON[item.status] ?? FiActivity}
                size="normal"
                className={styles[item.status.replace(/-/g, "_")] ?? styles.statusDefault}
              />
              {item.name}
              {item.durationSecs !== undefined && (
                <span className={styles.durationText}>({formatDurationRounded(item.durationSecs)})</span>
              )}
            </div>
          ))}
          {items.length > maxListLength && <div className={styles.moreText}>+ {items.length - maxListLength} more</div>}
        </div>
      </div>
    </>
  );
};
